import React from 'react';
import { Form, FormGroup, Label, Input, Row, Card, Col, Button, Alert  } from 'reactstrap';
import Marca from 'assets/img/logo/marca.png';
import autenticarse from '../core/useCases/autenticarse';
import Authentication from '../core/frameworks/Authentication';

export default class Login extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			username: '',
			password: '',
			loading: false,
			newUser: false,
			estadoError: false,
			mensajeError: '',
			visibleError: false
		};
	};



	handleChange = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	// oculta mensaje de error
	onDismiss = () => {
		this.setState({ visibleError: false });
	};


	callbackCorrecto = (data) => {

		
		this.props.history.push('/inicio')

		this.props.dataUser(data);

	
		
	};


	login = (e) => {
		e.preventDefault();
		this.setState({ loading: true });

		const { username, password } = this.state;

		autenticarse({
			username, 
			password, 
			Authentication,
			callbackCorrecto: this.callbackCorrecto,
			errorCallback: this.errorCallback
		});
	};

	errorCallback = (error) => {
		console.log(error);
		this.setState({ visibleError:true, estadoError:true, mensajeError: error, loading: false });
	};

	
	render() {
		const { username, password, loading, newUser, estadoError, mensajeError, visibleError } = this.state;

		return(
      		<Row style={{ height: '100vh', justifyContent: 'center', alignItems: 'center' }} className="no-mar-h">

				<Col md={6} lg={4}>
					<Card body className="borde-login">
						<Form onSubmit={this.login}>
							<div className="text-center pb-4">
								<img
									src={Marca}
									className="marca-login"
									alt="ETP"
									target='_blank' />
          					</div>

							{ 
								newUser &&	
									<Alert variant="success">
										<h6 className="alert-heading">¡Bienvenido!</h6>
										<p>Registro exitoso. Ingresa con tu correo y contraseña</p>
									</Alert>
							}
							{
								estadoError &&	
									<Alert color="danger" isOpen={visibleError} toggle={this.onDismiss} >
										<h6 className="alert-heading">Error</h6>
										<p>{mensajeError}</p>
									</Alert>
							}

							<FormGroup>
								<Label>Rut</Label>
								<Input placeholder="12345678-9" onChange={this.handleChange} value={username} name="username" />
							</FormGroup>

							<FormGroup>
								<Label>Contraseña</Label>
								<Input placeholder="Contraseña" type="password" onChange={this.handleChange} value={password} name="password" />
							</FormGroup>
							<hr/>
                          
							<Button disabled={loading} size="lg" type="submit" className="bg-gradient-theme-left border-0 btn-block" onClick={this.login}>
								{ loading ? 'Cargando...' : 'Ingresar' }
							</Button>
							<br/>
						</Form>


					</Card>
				</Col>
			</Row>
		);
	}
};
